module.exports = __webpack_public_path__ + "static/thumb-plaza-cataluna-6106ec93376385a64fbf1cd99450ec09.jpg";